<template src="../templates/list-view.html" />

<script setup>

import {
    computed, defineProps, ref, toRefs,
} from 'vue';
import { categoryFilters } from '../config/config';

const props = defineProps([
    // eslint-disable-next-line
    'groupedItems',
    // eslint-disable-next-line
    'results',
    // eslint-disable-next-line
    'selectedCategory',
    // eslint-disable-next-line
    'regionFilters',
    // eslint-disable-next-line
    'selectedRegion',
    // eslint-disable-next-line
    'isLoading',
]);
const {
    groupedItems, results, selectedCategory, regionFilters, selectedRegion,
} = toRefs(props);
const currentTab = ref();

const selectedCategoryObj = computed(() => {

    return categoryFilters.find((filter) => {

        return filter.category === parseInt(selectedCategory.value, 10);

    });

});

const getCategoryName = computed(() => {

    return (categoryId) => {

        const category = categoryFilters.find((cat) => cat.category === categoryId);
        return category ? category.title : '';

    };

});

</script>
